import { JSX } from 'react';

import Decimal from 'decimal.js';

import { Variant } from '@constants/common/ui.constants';

import { CommonTokenDto } from '@dto/common/tokens.dto';
import { FarmDto } from '@dto/vaults/vault-factory.dto';
import { VaultFarmsDto } from '@dto/vaults/vaults.dto';

export type HarvestInfoType = {
  harvestAmountUsd: Decimal;
  profitAmountUsd: Decimal;
};

export type VaultFarmsType = {
  farm: Omit<VaultFarmsDto, 'stakedBalance' | 'stakedUsd'> & {
    stakedBalance: Decimal;
    stakedUsd: Decimal;
    accountStakeBalance: Decimal;
    accountStakedUsd: Decimal;
    normalizeFarmPercent: Decimal;
    currentStakedPercent: Decimal;
  };
  farmInfo: Omit<FarmDto, 'stakingToken' | 'rewardTokens'> & {
    stakingToken: CommonTokenDto;
    rewardTokens: CommonTokenDto[];
    stakingTokenAddress: string;
    isV3: boolean;
  };
};

export type ActionItem = {
  label: string;
  value: string;
  icon: JSX.Element;
  onClick?: () => Promise<void> | void;
  isShow: boolean;
  copiedValue?: string;
  isActive?: boolean;
  isLoading?: boolean;
  variant?: Variant;
  isFullWidth?: boolean;
};

export type PendingRewardsType = {
  pendingRewardsUsd: Decimal;
  pendingRewards: Decimal;
  rewardToken: CommonTokenDto;
};

export type PendingRewardsWithAccountType = PendingRewardsType & {
  accountPendingRewards: Decimal;
  accountPendingRewardsUsd: Decimal;
};

export type EstimationFeesType = {
  estimateAmount: Decimal;
  estimateAmountUsd: Decimal;
  priceImpact: Decimal;
};

export type EstimateWithdrawType = {
  value: Decimal;
  valueUsd: Decimal;
  tokenId: number;
};

export enum ConnectorRangeWidth {
  Safe = 'safe',
  Common = 'common',
  Custom = 'custom',
  Full = 'full',
  None = 'none',
  Ailm = 'ailm',
}
